import * as React from "react";
import { UitkPlaceholderCard } from "uitk-react-cards";
import { IsomorphicCarousel } from "components/shared/IsomorphicCarousel/IsomorphicCarousel";
import { useLocalization } from "@shared-ui/localization-context";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { DealsPlaceholderProps } from "./typings";

// placeholder for the campaign deals that will be displayed until the data is fetched
export const DealsPlaceholder = (dealsPlaceholderProps: DealsPlaceholderProps) => {
  const { formatText } = useLocalization();
  const keyHelper = new ItemKeyHelper(`${dealsPlaceholderProps.flexComponentId}-placeholder-Carousel`);

  return (
    <div data-testid="deals-placeholder" className="Deals all-b-margin-three">
      <div className="all-t-margin-four">
        <UitkPlaceholderCard className="all-l-margin-three placeholder-header" />
        <UitkPlaceholderCard className="all-l-margin-three all-t-margin-two placeholder-subheader" />
        <IsomorphicCarousel
          className="carouselComponent all-t-margin-three"
          itemsVisible={{
            lg: 3,
            md: 2,
            sm: 1,
          }}
          buttonText={{
            nextButton: formatText("carousel.item.next"),
            prevButton: formatText("carousel.item.prev"),
          }}
          pageBy={1}
          peekWidth={24.8}
        >
          {[...Array(4)].map((val, index) => (
            <div key={keyHelper.next()} className="uitk-carousel-item uitk-cell">
              <UitkPlaceholderCard className="placeholder-card" />
            </div>
          ))}
        </IsomorphicCarousel>
      </div>
    </div>
  );
};
